import { useUserStore } from "../store/user";
import { createRouter, createWebHistory } from "vue-router";
import MainWrapper from "../views/MainWrapper";

const ACCESS_TOKEN = "app_access_token";

const routes = [
    {
        path: "/",
        component: MainWrapper,
        name: "MainWrapper",
        children: [
            {
                path: "login",
                name: "Login",
                component: () => import("../views/auth/Login.vue"),
                mode: "abstract",
                meta: {
                    title: "Shoptok Business Manager - Login",
                },
            },
            {
                path: "register",
                name: "Register",
                component: () => import("../views/auth/Register.vue"),
                meta: {
                    title: "Shoptok Business Manager - Register",
                },
            },
            {
                path: "forgot-password",
                name: "ForgotPassword",
                component: () => import("../views/auth/ForgotPassword.vue"),
                meta: {
                    title: "Shoptok Business Manager - Forgot Password",
                },
            },
            {
                path: "confirm-reset-password",
                name: "ConfirmResetPassword",
                component: () => import("../views/auth/ConfirmResetPassword.vue"),
            },
            {
                path: "resend-verification-mail",
                name: "ResendVerificationEmail",
                component: () => import("../views/auth/ResendVerificationEmail.vue"),
                meta: {
                    title: "Shoptok Business Manager - Resend Verification Email",
                },
            },
            {
                path: "/dashboard",
                name: "Dashboard",
                component: () => import("../views/dashboard/Dashboard.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Dashboard" },
            },
            {
                path: "/growth-formula",
                name: "GrowthFormula",
                component: () => import("../views/growth/GrowthFormula"),
                meta: {
                    requiresAuth: true,
                    notConfirmed: true,
                    title: "Shoptok Business Manager - Growth Formula",
                },
            },
            // Stranica TrustOk je sakrivena - ruta zakomentarisana da korisnik ne moze da je poseti.
            // {
            //     path: "/trust-ok",
            //     name: "TrustOk",
            //     component: () => import("../views/trustOk/TrustOk"),
            //     meta: {
            //         requiresAuth: true,
            //         notConfirmed: true,
            //         title: "Shoptok Business Manager - Trust Ok",
            //     },
            // },
            {
                path: "/products",
                name: "DashboardProducts",
                component: () => import("../views/dashboard/DashboardProducts"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Dashboard Products" },
            },
            {
                path: "/coupons/all",
                name: "CouponsRead",
                component: () => import("../views/coupons/Read"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - My Coupons" },
            },
            {
                path: "/coupons/add",
                name: "CouponsCreation",
                component: () => import("../views/coupons/Creation"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Coupon Creation" },
            },
            {
                path: "/coupons/edit/:id/:shop_id",
                name: "CouponsEdit",
                component: () => import("../views/coupons/Edit"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Edit Coupon" },
            },
            {
                path: "/coupons/faq",
                name: "CouponsFaq",
                component: () => import("../views/coupons/Faq"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Faq Coupons" },
            },
            {
                path: "/category",
                name: "DashboardCategoryV2",
                component: () => import("../views/dashboard/DashboardCategoryV2"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Dashboard Categories" },
            },
            {
                path: "/devices",
                name: "DashboardDevices",
                component: () => import("../views/dashboard/DashboardDevices"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Dashboard Devices" },
            },
            {
                path: "/activities",
                name: "DashboardActivities",
                component: () => import("../views/dashboard/DashboardActivities"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Dashboard Activities" },
            },
            {
                path: "/liquidity",
                name: "DashboardLiquidity",
                component: () => import("../views/dashboard/DashboardLiquidity"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Dashboard Liquidity" },
            },
            {
                path: "/distribution",
                name: "DashboardDistribution",
                component: () => import("../views/dashboard/DashboardDistribution"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Dashboard Distribution" },
            },
            // Stara lista lokacija (/shops) uklonjena — redirect na Store locations (DEV-4896).
            {
                path: "/shops",
                redirect: "/profile-seller/store-locations",
            },
            {
                path: "/price-list",
                name: "PriceList",
                component: () => import("../views/PriceList.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Price list" },
            },
            {
                path: "/limit-management",
                name: "LimitManagement",
                component: () => import("../views/LimitManagement.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Limit Management" },
            },
            {
                path: "/reports",
                name: "Reports",
                component: () => import("../views/Reports.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Reports" },
            },
            {
                path: "/profile",
                name: "Profile",
                component: () => import("../views/Profile.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Profile" },
            },
            {
                path: "/profile-seller/store-info",
                name: "StoreInfo",
                component: () => import("../views/sellerProfile/StoreInfo.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Store info" },
            },
            {
                path: "/profile-seller/payment-delivery",
                name: "PaymentDelivery",
                component: () => import("../views/sellerProfile/PaymentDelivery.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Payment & Delivery" },
            },
            {
                path: "/profile-seller/store-locations",
                name: "StoreLocations",
                component: () => import("../views/sellerProfile/StoreLocations.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Store locations" },
            },
            {
                path: "/bidding",
                name: "Bidding",
                component: () => import("../views/biddingV2/Bidding.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Bidding" },
            },
            {
                path: "/bidding/statistics",
                name: "BiddingStatistics",
                component: () => import("../views/biddingV2/BiddingStatistics.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Bidding Statistics" },
            },
            {
                path: "/bidding-category-overview",
                name: "BiddingCategoryOverview",
                component: () => import("../views/biddingOverview/BiddingCategoryOverview.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Bidding Category Overview" },
            },
            {
                path: "/bidding-seller-overview",
                name: "BiddingSellerOverview",
                component: () => import("../views/biddingOverview/BiddingSellerOverview.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Bidding Seller Overview" },
            },
            {
                path: "/seller-end-biddings",
                name: "SellerEndBiddings",
                component: () => import("../views/biddingOverview/BiddingSellerEndBiddingOverview.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Seller End Biddings" },
            },

            {
                path: "/product-ads-category-overview",
                name: "ProductAdsCategoryOverview",
                component: () => import("../views/productAdsOverview/ProductAdsCategoryOverview.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Product Ads Category Overview" },
            },
            {
                path: "/product-ads-seller-overview",
                name: "ProductAdsSellerOverview",
                component: () => import("../views/productAdsOverview/ProductAdsSellerOverview.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Product Ads Seller Overview" },
            },
            {
                path: "/seller-end-product-ads",
                name: "SellerEndProductAds",
                component: () => import("../views/productAdsOverview/ProductAdSellerEndOverview.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Seller End Product Ads" },
            },
            {
                path: "/product-ads-smart",
                name: "ProductAdSmart",
                component: () => import("../views/productAd/ProductAdSmart.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Product Ads Smart" },
            },
            {
                path: "/product-ads-boost",
                name: "ProductAdBoost",
                component: () => import("../views/productAd/ProductAdsBoost.vue"),
                meta: {requiresAuth: true, title: "Shoptok Business Manager - Product Ads Boost"}
            },
            {
                path: "/product-ad-insights",
                name: "ProductAdInsights",
                component: () => import("../views/productAd/ProductAdInsights.vue"),
                meta: {requiresAuth: true, title: "Shoptok Business Manager - Product Ads Insights"}
            },
            {
                path: "/accessTokens",
                name: "AccessTokens",
                component: () => import("../views/AccessTokens.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Access Tokens" },
            },
            {
                path: "/ticket-list",
                name: "TicketList",
                component: () => import("../views/ticketing/TicketList.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Ticket List" },
            },
            {
                path: "/ticket-new",
                name: "TicketNew",
                component: () => import("../views/ticketing/TicketNew.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Ticket New" },
            },
            {
                path: "/ticket-preview/:ticket_id",
                name: "TicketPreview",
                component: () => import("../views/ticketing/TicketPreview.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Ticket Preview" },
            },
            {
                path: "/clicks",
                component: () => import("../views/click/Clicks.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Dashboard Click insights" },
                children: [
                    {
                        path: "groups",
                        name: "ClickByGroup",
                        component: () => import("../views/click/ClickByGroup"),
                        meta: { requiresAuth: true },
                    },
                    {
                        path: "models",
                        name: "ClickByModel",
                        component: () => import("../views/click/ClickByModel"),
                        meta: { requiresAuth: true },
                    },
                    {
                        path: "",
                        name: "ClickAnalytics",
                        component: () => import("../views/click/ClickAnalytics"),
                        meta: { requiresAuth: true },
                    },
                ],
            },
            {
                path: "/members",
                name: "Members",
                component: () => import("../views/Members.vue"),
                meta: {
                    requiresAuth: true,
                    requiresAdminRole: true,
                    title: "Shoptok Business Manager - Members",
                },
            },
            {
                path: "/invites",
                name: "Invites",
                component: () => import("../views/Invites.vue"),
                meta: {
                    requiresAuth: true,
                    requiresAdminRole: true,
                    title: "Shoptok Business Manager - Invites",
                },
            },
            {
                path: "/prices",
                component: () => import("../views/product/Prices.vue"),
                meta: { requiresAuth: true, title: "Shoptok Business Manager - Prices" },
                children: [
                    {
                        path: "product-lowest-prices",
                        name: "ProductLowestPrices",
                        component: () => import("../views/product/ProductLowestPrices"),
                        meta: { requiresAuth: true },
                    },
                    {
                        path: "product-expensive-prices",
                        name: "ProductExpensivePrices",
                        component: () => import("../views/product/ProductExpensivePrices"),
                        meta: { requiresAuth: true },
                    },
                    {
                        path: "product-highest-prices",
                        name: "ProductHighestPrices",
                        component: () => import("../views/product/ProductHighestPrices"),
                        meta: { requiresAuth: true },
                    },
                    {
                        path: "",
                        name: "ProductPricesComparison",
                        component: () => import("../views/product/ProductPricesComparison"),
                        meta: { requiresAuth: true },
                    },
                ],
            },
            {
                path: "/module",
                name: "Module",
                component: () => import("../views/module/Module.vue"),
                meta: {
                    requiresAuth: true,
                    requiresAdminRole: true,
                    title: "Shoptok Business Manager - Members",
                },
            },
            {
                path: "/",
                name: "Home",
                component: () => import("../views/Home.vue"),
                meta: {
                    title: "Insider Intelligence | Eponuda & Shoptok",
                    description:
                        "Explore Insider Intelligence for retailers and brands. Track results, improve product visibility and reach shoppers across four markets with Eponuda and Shoptok.",
                    robots: "index, follow",
                    canonical: "https://business.shoptok.com/",
                    lang: "en",
                },
            },
            {
                path: "/:pathMatch(.*)*",
                name: "NotFound",
                component: () => import("../views/NotFound.vue"),
                meta: { title: "Shoptok Business Manager - Not Found" },
            },
        ],
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to) {
        return new Promise((resolve) => {
            setTimeout(() => {
                if (to.name === "Home" && to.params.section) {
                    resolve({ el: `#${to.params.section}`, behavior: "smooth" });
                } else {
                    resolve({ top: 0, behavior: "smooth" });
                }
            }, 600);
        });
    },
});

router.beforeEach(async (to) => {
    const userStore = useUserStore();

    if (to.meta.requiresAuth && !localStorage.getItem(ACCESS_TOKEN)) {
        return router.push({ name: "Login" });
    }

    if (to.meta.requiresAuth && !userStore.user) {
        await userStore.fetchUser();
    }

    if (!localStorage.getItem(ACCESS_TOKEN)) {
        if (to.meta.requiresAuth) {
            return router.push({ name: "Login" });
        }
    } else {
        if (to.name === "Login") {
            return router.push({ name: "Dashboard" });
        }
    }

    if (to.meta.requiresAdminRole && userStore.user.role_id === 3) {
        return router.push({ name: "Dashboard" });
    }
});

const upsertNamedMeta = (name, content) => {
    let tag = document.head.querySelector(`meta[name="${name}"]`);

    if (!content) {
        if (tag) {
            tag.remove();
        }
        return;
    }

    if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", name);
        document.head.appendChild(tag);
    }

    tag.setAttribute("content", content);
};

const upsertCanonical = (href) => {
    let tag = document.head.querySelector('link[rel="canonical"]');

    if (!href) {
        if (tag) {
            tag.remove();
        }
        return;
    }

    if (!tag) {
        tag = document.createElement("link");
        tag.setAttribute("rel", "canonical");
        document.head.appendChild(tag);
    }

    tag.setAttribute("href", href);
};

router.afterEach(async (to) => {
    document.title = to.meta?.title || "Shoptok Business Manager";
    upsertNamedMeta("description", to.meta.description || "");
    upsertNamedMeta("robots", to.meta.robots || "");
    upsertCanonical(to.meta.canonical || "");
    document.documentElement.lang = to.meta.lang || "";
});

export default router;